module.exports = __webpack_public_path__ + "static/belgium-25f1bfe958fd99093561c331f4bb3c2e.jpeg";